import * as tslib_1 from "tslib";
import './modal.less';
import { m } from '../hyperscript';
import { View } from './view';
var ModalOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(ModalOverlay, _super);
    function ModalOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalOverlay.prototype.render = function () {
        return (m("div", tslib_1.__assign({ className: "modal-overlay" }, this.attrs), this.children));
    };
    return ModalOverlay;
}(View));
export { ModalOverlay };
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Modal.prototype.render = function () {
        return null;
    };
    return Modal;
}(View));
export { Modal };
